<template>
  <div class="login-wrapper">
    <div class="login-header" style="background: url('static/images/header.png')">
      <div class="login-header-title">
        <h1>红砖智库系统</h1>
      </div>
    </div>
    <div class="login-body">
      <div class="login-container" v-if="!registerFlag">
        <Login @toRegister="toRegister"></Login>
      </div>
      <div class="register-container register-container-card" v-else>
        <Register @toLogin="toLogin"></Register>
      </div>
    </div>
    <div class="login-footer" style="background: url('static/images/header.png')">
      <img v-if="(SafeRecord != '' && SafeRecord != null)"
           src="static/images/record.png" style="width: 22px;padding-right: 5px"/>
      <a v-if="SafeRecord != undefined && SafeRecord != '' && SafeRecord != null" target="_blank"
         :href="safeUrl" style="padding-right: 20px">
        {{SafeRecord}}
      </a>
      <a v-if="ICPRecord != undefined && ICPRecord != '' && ICPRecord != null"
         target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">
        {{ICPRecord}}
      </a>
    </div>


    <!--    <div style="float: bottom;">-->
    <!--      <img src="static/images/header.png" class="bottom" style="position: fixed;bottom: 0"/>-->
    <!--    </div>-->
    <!--            <animation :loadingDataVisible="login.loadingDataVisible" :loadingText="'Loading'"></animation>-->

  </div>

</template>

<script>

import Register from "../components/Register";
import Login from "../components/Login";

export default {
  name: "Login1",
  components: {Register,Login},
  data() {
    return {
      registerFlag: false,
      SafeRecord: null,
      safeUrl: null,
      ICPRecord: null
    }
  },
  created(){
    this.$store.dispatch("getQrCodeParams")
    this.SafeRecord = window.config.websiteRecord.SafeRecord
    let SafeNum = window.config.websiteRecord.SafeNum
    this.safeUrl = "https://beian.mps.gov.cn/#/query/webSearch?code="+SafeNum
    this.ICPRecord = window.config.websiteRecord.ICPRecord
  },
  mounted(){
    if ('/register' === this.$route.path) {
      this.registerFlag = true;
    }
  },
  methods: {

    toRegister() {
      this.registerFlag = true;
    },
    toLogin(e) {
      this.registerFlag = false;
    },

  },
}

</script>

<style scoped>
.register-container-card {
  transition: width 200ms linear 0s, z-index 0s linear 0s;
}




</style>




// WEBPACK FOOTER //
// src/pages/Login.vue